import type { SYSAction } from "../../../../../../../../_ovlclient/src"
import { HookScreenNavigateIn_Type } from "../../../../../../../../_ovlclient/src/global/hooks"
import { DialogOkCancel } from "../../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import { ProcessIsRunning } from "../../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { ScreenCurrent } from "../../../../../../../../_ovlclient/src/library/screenapi"
import { TableGet } from "../../../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../../../_ovlclient/src/textapi"
import { ReShowOfferingInProgressSnack } from "../helpers"
import { actions } from "./actions"
import { OfferingDetailsRefresh, ResetDetailChanges } from "./helpers"

// const HookScreenRefresh: SYSAction<any> = async (context, { global }) => {
//   let state = global.getState()
//   let actions = global.getActions()
//   if (state.app.features.QUTOffering.detailsChanged) {
//     if ((await DialogOkCancel("Wollen Sie die Änderungen verwerfen?")) !== 1) {
//       return
//     }
//   }
//   await OfferingDetailsRefresh(state, actions, context, true)
// }

const HookScreenNavigateOut: SYSAction = async (_, { global }) => {
  let state = global.getState()
  if (
    !(
      ProcessIsRunning("QUTOfferingRecalcStatus") ||
      ProcessIsRunning("GENNewOfferUpload")
    ) &&
    state.app.features.QUTOffering.detailsChanged
  ) {
    if ((await DialogOkCancel(T("QUTOfferingCancelDetailChanges"))) === 2) {
      return true
    }
  }
  ResetDetailChanges()
}

const HookScreenNavigateIn: SYSAction<HookScreenNavigateIn_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let offeringState = state.app.features.QUTOffering
  let actions = global.getActions()
  //let def = TableGet("QUTOfferingMaterial").def

  let tb = TableGet("QUTOffering")

  let rowKey = value.instance
  offeringState.selectedOfferKey = rowKey //tb.rows[rowKey].DocEntry
  offeringState.selectedOfferType = tb.rows[rowKey].U_ITF_PRT_OfferType
  offeringState.offerMainType = tb.rows[rowKey].U_ITF_PRT_OfferMainType

  //let isCut = state.app.features.QUTOffering.offerMainType === "CUT"
  // def.features.edit = !isCut
  // def.columns["Skl"].ui.visibility = !isCut ? "Table_Edit_View" : "None"

  await OfferingDetailsRefresh(
    state,
    actions,
    value.instance,
    !state.app.features.QUTOffering.detailsChanged
  )

  if (ScreenCurrent() !== "QUTOffering") {
    ReShowOfferingInProgressSnack()
  }
}

let hooks = {
  /*HookScreenRefresh,*/ HookScreenNavigateIn,
  HookScreenNavigateOut,
}
export let QUTOfferingDetails = { actions, hooks }
